import { useContext, useEffect } from 'react';

import { ToastComponent } from '../../components/ToastComponent';
import {
  GET_SAM_TYPES,
  GET_SAM_TYPES_ERROR,
  GET_SAM_TYPES_SUCCESS,
} from '../../constants/constantsRed';
import { StoreContext } from '../../context/Provider';
import useApi from '../../services/request.service';

export const useSamTypes = () => {
  const { getSamTypesStates } = useContext(StoreContext);

  const { genericApiCallApiBilling } = useApi();

  const getSamTypes = async () => {
    getSamTypesStates.dispatch({ type: GET_SAM_TYPES });

    // Call the API to get SAM types
    return await genericApiCallApiBilling('/v1.0/sam-types', 'GET', {}, {}, {})
      .then((result: any) => {
        if (result.status === 200) {
          const payload = result.data;
          getSamTypesStates.dispatch({
            type: GET_SAM_TYPES_SUCCESS,
            payload: payload,
          });
          return result;
        }
      })
      .catch((error: any) => {
        ToastComponent(
          'warning',
          'Error',
          'Error al obtener tipos de SAM, intente más tarde por favor. : ' +
            error.message
        );
        getSamTypesStates.dispatch({
          type: GET_SAM_TYPES_ERROR,
          payload: error.message,
        });
      });
  };

  useEffect(() => {
    if (
      getSamTypesStates.state.loading == false &&
      getSamTypesStates.state.data === null &&
      getSamTypesStates.state.error === null
    ) {
      getSamTypes();
    }
  }, [getSamTypesStates.state]);

  return { getSamTypes };
};
